module.exports = __webpack_public_path__ + "img/service-bg.94530a8.png";